import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Whxq from '../views/Whxq.vue'
import Ghidorah from '../views/Ghidorah.vue'
import Phixsoul from '../views/Phixsoul.vue'
import Ben from '../views/Ben.vue'
// import Link from '../views/Link.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/whxq',
    name: 'whxq',
    component: Whxq
  },
  {
    path: '/ghidorah',
    name: 'ghidorah',
    component: Ghidorah
  },
  {
    path: '/phixsoul',
    name: 'phixsoul',
    component: Phixsoul
  },
  {
    path: '/ben',
    name: 'ben',
    component: Ben
  },
  {
    path: '*',
    redirect: '/'
  }
  // {
  //   path: '/link',
  //   name: 'Link',
  //   component: Link
  // }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router
